import { render } from "./AddNewMsisdnClassEditor.vue?vue&type=template&id=efd5265c"
import script from "./AddNewMsisdnClassEditor.vue?vue&type=script&lang=js"
export * from "./AddNewMsisdnClassEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__